export const NAVIGATION: { title: Translation; url: string }[] = [
  {
    title: ["common:navigation.home", "Home"],
    url: "/",
  },
  {
    title: ["common:navigation.guides", "Guides"],
    url: "/guides",
  },
];
